export const LastDayOfProgram = {
	ProgramName: 'coachProgNm',
	Action: 'coachProgAction',
	ProgramStart: 'coachProgStart',
	ProgramEnd: 'coachProgEnd',
	ProgramDuration: 'coachProgDuration',
	Language: 'coachLanguage',
	LevelStatus: 'coachLevelStatus',
	LevelPoints: 'coachLevelPoints',
};
